import { types } from '../actions/root';
var resetState = function (state) {
    return {
        locale: state.locale,
    };
};
var resetStateExceptAuth = function (state) {
    return {
        locale: state.locale,
        authenticate: state.authenticate,
    };
};
var getRootReducer = function (appReducer) {
    return function (state, action) {
        var returnedState = state;
        switch (action.type) {
            case types.RESET_STATE:
                returnedState = resetState(state);
                break;
            case types.RESET_STATE_EXCEPT_AUTH:
                returnedState = resetStateExceptAuth(state);
                break;
        }
        return appReducer(returnedState, action);
    };
};
export default getRootReducer;
//# sourceMappingURL=root.js.map